"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAddressDataKey = getAddressDataKey;
exports.getAddressRows = getAddressRows;
exports.lowerCasedKey = lowerCasedKey;
function lowerCasedKey(key) {
  if (key.length === 0) {
    return key;
  }
  return key.slice(0, 1).toLowerCase() + key.slice(1);
}
function getAddressDataKey(key) {
  switch (key) {
    case 'ZipCode':
      return 'zipcode';
    default:
      return lowerCasedKey(key);
  }
}
function getAddressRows(addressData, addressFormat) {
  if (addressData == null || !addressFormat) {
    return [];
  }
  const result = [];
  const {
    lines
  } = addressFormat;
  /*
  The fields array are names of address fields to be found in addressData
  and concatenated into an address row string. There must be fields.length + 1
  total items in the separators array, from which the 1st is row prefix, last
  is row suffix, and the rest in the middle are the actual field separators.
  */
  lines.forEach(({
    fields,
    separators
  }) => {
    let row = '';
    fields.forEach((field, index) => {
      const fieldValue = addressData[getAddressDataKey(field)];
      if (fieldValue === null) {
        return;
      }

      // add row prefix or separator
      if (index === 0 || fieldValue !== undefined) {
        row += separators[index];
      }
      // add field value
      if (fieldValue !== undefined) {
        row += String(fieldValue);
      }
      // add row suffix
      if (index === fields.length - 1) {
        row += separators[index + 1];
      }
    });
    // add only non-empty rows to the result
    const finalRow = row.trim();
    if (finalRow) {
      result.push(finalRow);
    }
  });
  return result;
}
//# sourceMappingURL=getAddressRows.js.map